import * as React from "react";
import {ReactElement, useMemo} from "react";
import {connect} from "react-redux";
import {Box, styled} from "@mui/material";
import {IPageProps} from "../interfaces/components/props/IPageProps";
import ImageGrid from "../components/grid/ImageGrid";
import {CAREER_SECTIONS, PERSONAL_PROJECTS} from "../Config";
import {RootState} from "../redux/store";
import Quotes from "./Quotes";
import TabsContainer from "../components/tab/TabsContainer";
import VerticalTimeline from "../components/timeline/VerticalTimeline";
import {useParams} from "react-router-dom";
import {Helmet} from "react-helmet-async";

const Root = styled(Box)(({theme}) => ({
    minHeight: '100%',
    height: 'auto',
    [theme.breakpoints.only('xs')]: {
        padding: `${theme.spacing(8)} ${theme.spacing(0)} `,
    },
    [theme.breakpoints.up('sm')]: {
        padding: `${theme.spacing(0)} ${theme.spacing(8)} ${theme.spacing(0)} ${theme.spacing(8)}`,
    },
}));

interface IProps extends IPageProps {
}

function Home({languageTokens}: IProps): ReactElement {

    const personalProjects = useMemo(() => PERSONAL_PROJECTS(languageTokens), [languageTokens]);
    const careerSections = useMemo(() => CAREER_SECTIONS(languageTokens), [languageTokens]);
    const {lang} = useParams(); // optional if you use language param

    return (
        <Root id={'Home'}>
            {(lang === 'de' || lang === 'en') &&
                <Helmet>
                    <title>Personal Projects</title>
                    <meta name="description" content="Explore several projects I worked on in my spare time"/>
                    <link rel="alternate" href={`https://timfehrmann.com/en/`} hrefLang="en"/>
                    <link rel="alternate" href={`https://timfehrmann.com/de/`} hrefLang="de"/>
                    <link rel="canonical" href={`https://timfehrmann.com/${lang}/`}/>
                    <link rel="alternate" href="https://timfehrmann.com/" hrefLang="x-default"/>
                </Helmet>
            }
            <Quotes/>
            <TabsContainer
                basePath={`/${lang}`}
                tabs={[
                    {
                        tabName: '',
                        headerText: languageTokens.personal,
                        content: <ImageGrid projectPages={personalProjects}/>,
                    },
                    {
                        tabName: 'career',
                        headerText: languageTokens.career,
                        content: <VerticalTimeline careerSections={careerSections}/>,
                    },
                ]}
            />
        </Root>
    );
}

const mapStateToProps = (state: RootState) => ({
    languageTokens: state.language.languageTokens,
});

const mapActionsToProps = {};

export default connect(mapStateToProps, mapActionsToProps)(Home);
